/**
 * @machina/system-doomsworn — Doomsworn for Machina VTT
 *
 * d20-derived, lethal and light. Not a 5e hack.
 *
 * The engine layer is kept verbatim (d20 + mod vs DC, AC, HP, the six
 * abilities, advantage/disadvantage, initiative, conditions, Open5e monsters
 * as printed) so nothing in the existing VTT breaks. Above that layer:
 * ATTUNEMENT as a seventh ability, Roles instead of classes, concession-based
 * advancement, the Doom Die, Wear, the Tilt, and three magic pillars that
 * behave nothing like each other.
 *
 * Home world: The Long Indenture (`docs/worlds/long-indenture/WORLD.md`).
 * Rules of record: `docs/systems/doomsworn.md`.
 */
// --- Adapter & rules ---
export { doomswornAdapter, DOOMSWORN_RULES, CONCESSION_CAP, DOOM_DIE_GROWTH_STEPS, getProficiencyBonus, } from './doomsworn-adapter.js';
// --- Character surface (creation wizard + sheet sections) ---
export { doomswornCreationSpec, doomswornSheetSections, attunementDisplay, DOOMSWORN_STANDARD_ARRAY, } from './sheet.js';
// --- Abilities (including ATTUNEMENT and its bestiary-safe default) ---
export { ATTUNEMENT, CORE_ABILITY_IDS, DOOMSWORN_ABILITY_IDS, DOOMSWORN_ABILITIES, getModifier, getAttunementScore, getAttunementModifier, hasAttunement, normalizeAbilities, } from './abilities.js';
// --- Roles ---
export { DOOMSWORN_ROLES, DOOMSWORN_ROLE_CLASSES, DEFAULT_ROLE_ID, getRole, } from './roles.js';
// --- Conditions & AI GM guidance ---
export { DOOMSWORN_CONDITIONS } from './conditions.js';
export { DOOMSWORN_DM_GUIDANCE } from './guidance.js';
// --- Pillar I: Pacts ---
export { PACT_TIER_SCALE, CALLING_THRESHOLDS, reckoningDC, resolveReckoning, applyReckoning, crossedCallingThreshold, } from './pacts.js';
// --- Pillar I: the Pact Ledger (stateful) ---
export { openLedger, entryFor, debtTo, totalDebt, openLiens, openCallings, invertedPowers, validateDraw, draw, satisfyLien, answerCalling, refuseCalling, pursueAppetite, tableDebtTo, ledgerLean, } from './ledger.js';
// --- The Powers of record ---
export { KETHREM, DOOMSWORN_POWERS, getPower } from './powers.js';
// --- Pillar II: Runes ---
export { RUNE_NAMES, RUNE_RATING_MAX, RUNE_SCHOOLS, GRIP_MARK_THRESHOLDS, GRIP_AUTONOMY_THRESHOLD, GRIP_CEILING, ATTUNEMENT_COST_PER_RATING, runeRatingCeiling, attunementCostToRaise, resolveRuneCheck, applyRuneCheck, } from './runes.js';
// --- Pillar III: Cast ---
export { CAST_MAX_SPELL_LEVEL, CAST_SLOT_TABLE, getCastSlots, castDC, resolveCastCheck, } from './cast.js';
// --- The Doom Die ---
export { DOOM_DIE_TRACK, DOOM_CLOCK_SEGMENTS, DOOM_CLOCK_WEAR_THRESHOLDS, newDoomState, doomDieSides, growDoomDie, spendDoomDie, segmentsRemaining, } from './doom.js';
// --- The resolution hook: the pause between the d20 and the narration ---
export { openResolution, describeOffer, declineDoom, spendDoom, doomTradeSummary, canSpendDoom, } from './resolution.js';
// --- Persistence: state that survives a reload and a new session ---
export { DOOMSWORN_STATE_KEY, DOOMSWORN_STATE_VERSION, DoomswornCharacterStateSchema, DoomswornCampaignStateSchema, emptyState, emptyCampaignState, readCharacterState, readCampaignState, loadCharacterState, writeCharacterState, toRuntime, fromRuntime, } from './persistence.js';
// --- The engine's report to the narrator ---
export { describeCharacter, describeEngineState, } from './gm-brief.js';
// --- Wear ---
export { addWear, wearCount } from './wear.js';
// --- The Tilt ---
export { TILT_LAW_POLE, TILT_CHAOS_POLE, TILT_NEUTRAL_BAND, clampTilt, ascendantSide, tiltLabel, tiltPactModifier, tiltCastModifier, tiltRuneModifier, applyDrawToTilt, } from './tilt.js';
// Auto-register on import
import { registerSystem } from '@machina/core';
import { doomswornAdapter } from './doomsworn-adapter.js';
registerSystem(doomswornAdapter);
//# sourceMappingURL=index.js.map